<!--
  File name: Dashboard.vue
  Program Description:
    - This is the component where the pages AppBar, Drawer, and Footer are
    being rendered.

-->

<template>
  <v-app id="inspire">
    <AppBar v-if="drawer">
      <!-- <template v-slot:title>
        {{ $data.$meta.app.name }}
      </template> -->
      <template
        v-slot:menu
      >
        <slot name="menu" />
      </template>
    </AppBar>
    <v-container
      v-if="!drawer"
      class="logo"
    >
      <v-img
        :src="`${$metaData.app.logo}`"
        height="100%"
        width="100%"
      />
    </v-container>
    <Drawer
      v-if="drawer"
      id="drawer-menu"
      :title="drawerTitle"
      :subtitle="drawerSubtitle"
    >
      <slot name="drawer" />
    </Drawer>
    <v-main>
      <slot name="content" />
    </v-main>
    <Footer v-if="hideTermsPrivacy" />
  </v-app>
</template>

<script>
import AppBar from '@/components/AppBar'
import Footer from '@/components/Footer'
// import Card from '@/components/Card'
import Drawer from '@/components/Drawer'
import { metaMixin } from '@/meta'

export default {
  name: 'App',
  components: {
    AppBar,
    Footer,
    Drawer
  },
  mixins: [metaMixin],
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    'show-drawer': { type: Boolean, default: false },
    drawerTitle: { type: String, default: undefined },
    drawerSubtitle: { type: String, default: undefined }
  },
  data: () => ({
  }),
  computed: {
    hideTermsPrivacy () {
      const list = ['PassReset', 'PassResetLink']
      const bool = !list.includes(this.$route.name)
      return bool
    },
    drawer () {
      const list = ['Login', 'PassReset', 'Signup', 'PassResetLink', 'InternalLogin']
      const bool = !list.includes(this.$route.name)
      return bool
    }
  },
  methods: {
  }
}
</script>

<style>
  .logo {
    position: absolute;
    z-index: 2;
    width: 20%;
    height: 20%;
    margin-top: 1%;
    margin-left: 1%
  }
  .logo img {
    position: absolute;
    top: 0px;
    right: 0px;
  }
</style>
